import { render, staticRenderFns } from "./DynamicQuestionnaire.vue?vue&type=template&id=21e954a4&"
import script from "./DynamicQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./DynamicQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./DynamicQuestionnaire.vue?vue&type=style&index=0&id=21e954a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports